import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import { getRenderable } from '../../lib/index';
import ContentWrapper from '../../ContentWrapper';

import Header from './Header';
import Body from './Body';
import Footer from './Footer';

import sassVars from './index.scss';

class Base extends Modal {

    __view(props) {

        const {
            header,
            footer,
            children,
            hasCloseBtn
        } = this.props;

        const className = `MODAL__modal-content-base-${sassVars.uid}`;

        return (
            <ContentWrapper {...props} className={className}>
                {header && <Header hasCloseBtn={hasCloseBtn} close={props.close}>{getRenderable(header, props)}</Header>}
                {children && <Body>{getRenderable(children, props)}</Body>}
                {footer && <Footer>{getRenderable(footer, props)}</Footer>}
            </ContentWrapper>
        );
    }
}

Base.propTypes = {
    header: PropTypes.any,
    footer: PropTypes.any,
    children: PropTypes.any,
    hasCloseBtn: PropTypes.bool
};

export default Base;
